import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, YtKontrolaEmail, NotificationService } from 'yt-ng-framework';
import { KomitentEmail } from './komitent-email';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-email-update',
  templateUrl: './komitent-email-update.component.html'
})
export class KomitentEmailUpdateComponent extends BaseUpdateComponent<KomitentEmail> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'KOMITENTEMAIL.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'KOMITENTEMAIL.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Opis", Validators.maxLength(100), 'maxlength', 'KOMITENTEMAIL.OPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SvojinaID", Validators.required, 'required', 'KOMITENTEMAIL.SVOJINA.VALIDATION.REQUIRED');
    
    this.baseFormGroup.setValidators(EmailKontrola('Naziv'));
    this.baseFormGroup.updateValueAndValidity();
  } 

}

function EmailKontrola(emailKey:string){
  return (group: FormGroup): {[key : string]: any} =>{
    let email : string = group.controls[emailKey].value;
    let emailProvera : boolean = YtKontrolaEmail(email);
    if (emailProvera == false)
      return { checkEmail :{valid:false, message: 'KOMITENTEMAIL.NAZIV.VALIDATION.PATTERN'}};
    else
      return null;
  }
}
